(function () {
  'use strict';

  const selectors = {
    button: '[data-cart-clear]',
  };

  const classes = {
    loading: 'is-loading',
  };

  const attributes = {
    url: 'data-url',
    confirm: 'data-confirm',
  };

  class CartClear extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector(selectors.button);
      this.url = this.getAttribute(attributes.url);

      if (!this.button || !this.url) return;

      this.loading = false;
      this.onClickEvent = (event) => this.onClick(event);
      this.button.addEventListener('click', this.onClickEvent);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClickEvent);
    }

    onClick(event) {
      event.preventDefault();

      if (this.loading) return;

      const confirmMessage = this.getAttribute(attributes.confirm);

      if (confirmMessage && !window.confirm(confirmMessage)) return;

      this.loading = true;
      this.button.classList.add(classes.loading);
      this.button.setAttribute('disabled', 'true');

      fetch(this.url, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({}),
      })
        .then((response) => response.json())
        .then(() => {
          // Let the cart rebuild itself the same way a line item removal does.
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.loading = false;
          this.button.classList.remove(classes.loading);
          this.button.removeAttribute('disabled');
        });
    }
  }

  if (!customElements.get('cart-clear')) {
    customElements.define('cart-clear', CartClear);
  }
})();
